import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25e88a22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "surface-50" }
const _hoisted_2 = { class: "p-2 surface-border border-bottom-2" }
const _hoisted_3 = { class: "flex flex-column md:flex-row md:justify-content-between" }
const _hoisted_4 = { class: "pb-2 pt-2" }
const _hoisted_5 = {
  key: 0,
  class: "p-2 ml-5"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-clock" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "w-5 grid"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "partner",
  class: "col-12 p-0 pl-2 mt-1 md:col-2 md:mb-0 md:p-2"
}, "Partner", -1))
const _hoisted_9 = { class: "col-12 p-0 pl-2 md:col-7 md:p-2" }
const _hoisted_10 = {
  key: 0,
  class: ""
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "" }
const _hoisted_13 = {
  key: 0,
  class: "p-2 surface-border border-bottom-2 flex flex-row flex-wrap align-items-center"
}
const _hoisted_14 = { class: "pb-2 pt-2 font-medium text-xl uppercase" }
const _hoisted_15 = { class: "flex flex-row flex-wrap h-full" }
const _hoisted_16 = { class: "w-6 m-2 p-2 surface-card shadow-2 border-round-lg h-full align-items-center justify-content-center" }
const _hoisted_17 = {
  key: 1,
  class: "w-9 ml-2 mt-2 surface-card shadow-2 border-round-lg h-full align-items-center justify-content-center"
}
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "flex flex-row flex-wrap" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-clock" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-clock" }, null, -1))
const _hoisted_22 = { class: "mr-1 font-medium" }
const _hoisted_23 = { class: "mr-1 font-medium" }
const _hoisted_24 = { class: "font-medium" }
const _hoisted_25 = { class: "bottom-action-row" }
const _hoisted_26 = { class: "mr-5 ml-5" }
const _hoisted_27 = ["href"]
const _hoisted_28 = {
  key: 0,
  class: "ml-1 ext-muted fs-6 text-lg text-yellow-500"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "email bol už zaslaný", -1))
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tag = _resolveComponent("Tag")!
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_InputGroupAddon = _resolveComponent("InputGroupAddon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_CardFix = _resolveComponent("CardFix")!
  const _component_UploadFiles = _resolveComponent("UploadFiles")!
  const _component_AttachmentList = _resolveComponent("AttachmentList")!
  const _component_Card = _resolveComponent("Card")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_EmailList = _resolveComponent("EmailList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode("Odberateľ: " + _toDisplayString(this.store.order.user.company) + " (", 1),
            _createElementVNode("em", null, _toDisplayString(this.store.order.user.firstName) + " " + _toDisplayString(this.store.order.user.lastName) + ", " + _toDisplayString(this.store.order.user.phone), 1),
            _createTextVNode(") ")
          ]),
          _createElementVNode("div", null, [
            _createTextVNode("Aktuálny stav: "),
            _createVNode(_component_Tag, {
              class: "p-2 ml-1 font-medium text-base",
              value: this.store.order.currentState.label,
              severity: $options.Utils.getStateSeverity(this.store.order.currentState.reference)
            }, null, 8, ["value", "severity"])
          ]),
          (this.store.order.id > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("em", null, [
                  _createTextVNode("Objednávka naposledy uložená "),
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString($options.Utils.parseToSlovakDateTime(this.store.order.modifiedDate)) + " - " + _toDisplayString(this.store.order.modifiedUser.firstName) + " " + _toDisplayString(this.store.order.modifiedUser.lastName), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        ($data.store.user.role.id === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_PrimevueSelect, {
                  id: "partner",
                  modelValue: $data.selectedPartner,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.selectedPartner) = $event)),
                  options: $data.store.partners,
                  optionLabel: "firstName",
                  placeholder: "Vyber partnera",
                  class: "w-full"
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value.id != 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", null, _toDisplayString(slotProps.value.company ? slotProps.value.company + ' - ' : '') + " " + _toDisplayString(slotProps.value.firstName) + " " + _toDisplayString(slotProps.value.lastName), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(slotProps.placeholder), 1))
                  ]),
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", null, _toDisplayString(slotProps.option.company ? slotProps.option.company + ' - ' : '') + " " + _toDisplayString(slotProps.option.firstName) + " " + _toDisplayString(slotProps.option.lastName), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (this.store.order.id > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, "#" + _toDisplayString(this.store.order.orderNumber) + " - " + _toDisplayString(this.store.type.name), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_InputGroup, { class: "h-2rem" }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "wfloorlab h-full font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Meno a priezvisko ")
                ]),
                _: 1
              }),
              _createVNode(_component_InputText, {
                class: "justify-content-start wfloorinp",
                inputStyle: { background: '#b8d6f0', textAlign: 'left' },
                name: "nameSurname",
                id: "nameSurname",
                placeholder: "Zadaj meno a priezvisko",
                "required:string": "required",
                modelValue: this.store.order.customerName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.store.order.customerName) = $event)),
                autocomplete: "nameSurname-new"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_InputGroupAddon, { class: "wterminlab h-full font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Mobilný kontakt ")
                ]),
                _: 1
              }),
              _createVNode(_component_InputText, {
                class: "wtermincal justify-content-start",
                inputStyle: "background: #b8d6f0; text-align: left",
                name: "phone",
                id: "phone",
                placeholder: "Zadaj telefón",
                "required:string": "required",
                modelValue: this.store.order.phone,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.store.order.phone) = $event)),
                autocomplete: "phone-new"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_InputGroup, { class: "h-2rem mt-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "wfloorlab h-full font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Adresa ")
                ]),
                _: 1
              }),
              _createVNode(_component_InputText, {
                class: "justify-content-start wfloorinp",
                inputStyle: "background: #b8d6f0; text-align: left",
                name: "address",
                id: "address",
                placeholder: "Zadaj adresu",
                "required:string": "required",
                modelValue: this.store.order.address,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.store.order.address) = $event)),
                autocomplete: "address-new"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_InputGroupAddon, { class: "wterminlab h-full font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("E-mail ")
                ]),
                _: 1
              }),
              _createVNode(_component_InputText, {
                type: "email",
                class: "wtermincal justify-content-start",
                inputStyle: "background: #b8d6f0; text-align: left",
                name: "email",
                id: "email",
                placeholder: "Zadaj e-mail",
                "required:string": "required",
                modelValue: this.store.order.email,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.store.order.email) = $event)),
                autocomplete: "email-new"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_InputGroup, { class: "h-2rem mt-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "wfloorlab-2 h-full font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Poschodie ")
                ]),
                _: 1
              }),
              _createVNode(_component_InputNumber, {
                inputId: "poschodie",
                class: "justify-content-start wfloorinp-2",
                inputStyle: "background: #b8d6f0; text-align: left",
                name: "floor",
                id: "floor",
                placeholder: "Zadaj poschodie",
                "required:string": "required",
                modelValue: this.store.order.floor,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.store.order.floor) = $event)),
                autocomplete: "floor-new"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_InputGroupAddon, { class: "wterminlab h-full font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Termín montáže ")
                ]),
                _: 1
              }),
              _createVNode(_component_Calendar, {
                class: "wtermincal-2",
                modelValue: $data.termin,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.termin) = $event)),
                showIcon: "",
                dateFormat: "dd.mm.yy"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.order.fixes, (fix, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "align-items-center justify-content-center w-12 surface-card shadow-2 border-round-lg p-2 m-2"
        }, [
          _createVNode(_component_CardFix, {
            fixKey: index,
            validationOK: true,
            onChangeFix: $options.saveFixes,
            onDeleteFix: $options.deleteFix
          }, null, 8, ["fixKey", "onChangeFix", "onDeleteFix"])
        ]))
      }), 128)),
      (this.store.order.id > 0 && $data.store.order.user.role.id === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_UploadFiles, {
              orderId: String(this.store.order.id)
            }, null, 8, ["orderId"])
          ]))
        : _createCommentVNode("", true),
      (this.store.order.id > 0 && $data.store.order.user.role.id === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_component_AttachmentList, {
              orderId: String(this.store.order.id)
            }, null, 8, ["orderId"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_Card, { class: "shadow-2 m-2 w-3" }, {
          title: _withCtx(() => [
            _createTextVNode("Prehľad stavov")
          ]),
          content: _withCtx(() => [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.orderHistory, (history) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: history.id
                }, [
                  _hoisted_20,
                  _createTextVNode(" " + _toDisplayString($options.Utils.formatToSlovak(history.createDate)) + " ", 1),
                  _createVNode(_component_Tag, {
                    value: history.state.label,
                    severity: $options.Utils.getStateSeverity(history.state.reference)
                  }, null, 8, ["value", "severity"]),
                  _createTextVNode(" - " + _toDisplayString(history.user.firstName) + " " + _toDisplayString(history.user.lastName), 1)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        (this.store.emailHistories.length > 0)
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 0,
              class: "shadow-2 m-2 w-6"
            }, {
              title: _withCtx(() => [
                _createTextVNode("Prehľad histórie zaslaných emailov")
              ]),
              content: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.emailHistories, (history) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: history.id
                    }, [
                      _hoisted_21,
                      _createTextVNode(" " + _toDisplayString($options.Utils.formatToSlovak(history.createDate)) + " Od: ", 1),
                      _createElementVNode("span", _hoisted_22, _toDisplayString(history.user.firstName) + " " + _toDisplayString(history.user.lastName), 1),
                      _createTextVNode(" Komu: "),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(history.whom), 1),
                      _createTextVNode(" Predmet: "),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(history.subject), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("a", {
        class: "mr-5",
        onClick: _cache[7] || (_cache[7] = ($event: any) => ($options.saveOrder()))
      }, [
        _createVNode(_component_PrimevueButton, {
          label: "ULOŽIŤ a PREPOČÍTAŤ",
          raised: "",
          class: "uppercase",
          disabled: $data.store.user.role.id === 2 ? this.store.hasBeenSent : false,
          severity: "info",
          icon: "pi pi-save"
        }, null, 8, ["disabled"])
      ]),
      _createElementVNode("a", _hoisted_26, [
        _createVNode(_component_PrimevueButton, {
          class: "mr-5",
          label: "Pridať fix",
          disabled: $data.store.user.role.id === 2 ? this.store.hasBeenSent : false,
          severity: "success",
          icon: "pi pi-plus",
          raised: "",
          onClick: _cache[8] || (_cache[8] = ($event: any) => ($options.addFix()))
        }, null, 8, ["disabled"])
      ]),
      (this.store.order.id > 0 && ($data.store.user.role.id === 1 || $data.store.user.role.id === 2))
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "mr-2 ml-2",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (!this.store.hasBeenSent ? $options.Utils.changeState($options.Models.State.SENT) : null))
          }, [
            _createVNode(_component_PrimevueButton, {
              label: "Odoslať",
              raised: "",
              class: "uppercase",
              severity: $options.Utils.getStateSeverity($options.Models.State.SENT),
              disabled: this.store.hasBeenSent
            }, null, 8, ["severity", "disabled"])
          ]))
        : _createCommentVNode("", true),
      (this.store.order.id > 0 && $data.store.user.role.id !== 2)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "mr-2 ml-2",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (!this.store.hasBeenInProduction ? $options.Utils.changeState($options.Models.State.PRODUCTION): null))
          }, [
            _createVNode(_component_PrimevueButton, {
              label: $data.store.user.role.id === 3 ? 'Odoslať do výroby' : 'Nastaviť výrobu',
              raised: "",
              class: "uppercase",
              severity: $options.Utils.getStateSeverity($options.Models.State.PRODUCTION),
              disabled: this.store.hasBeenInProduction
            }, null, 8, ["label", "severity", "disabled"])
          ]))
        : _createCommentVNode("", true),
      (this.store.order.id > 0 && $data.store.user.role.id !== 2)
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            class: "mr-2 ml-2",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (!this.store.hasBeenReady && this.store.hasBeenInProduction ? $options.Utils.changeState($options.Models.State.READY): null))
          }, [
            _createVNode(_component_PrimevueButton, {
              label: "Pripravená na prevzatie",
              raised: "",
              class: "uppercase",
              severity: $options.Utils.getStateSeverity($options.Models.State.READY),
              disabled: this.store.hasBeenReady ||  !this.store.hasBeenInProduction || !this.store.hasBeenSent
            }, null, 8, ["severity", "disabled"])
          ]))
        : _createCommentVNode("", true),
      (this.store.order.id > 0 && $data.store.user.role.id !== 2)
        ? (_openBlock(), _createElementBlock("a", {
            key: 3,
            class: "mr-2 ml-2",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (!this.store.hasBeenFinished && this.store.hasBeenReady ? $options.Utils.changeState($options.Models.State.FINISH): null))
          }, [
            _createVNode(_component_PrimevueButton, {
              label: "Ukončená",
              raised: "",
              class: "uppercase",
              severity: $options.Utils.getStateSeverity($options.Models.State.FINISH),
              disabled: !this.store.hasBeenReady || this.store.hasBeenFinished
            }, null, 8, ["severity", "disabled"])
          ]))
        : _createCommentVNode("", true),
      ($data.store.user.role.id !== 3 && this.store.emailLink !== '')
        ? (_openBlock(), _createElementBlock("a", {
            key: 4,
            class: "mr-2 ml-2",
            href: this.pdfGlassUrl,
            target: "_blank"
          }, [
            _createVNode(_component_PrimevueButton, {
              label: "PDF sklá",
              raised: "",
              class: "uppercase",
              severity: "secondary",
              icon: "pi pi-eye"
            })
          ], 8, _hoisted_27))
        : _createCommentVNode("", true),
      ($data.store.user.role.id !== 2 && this.store.emailLink !== '')
        ? (_openBlock(), _createElementBlock("a", {
            key: 5,
            onClick: _cache[13] || (_cache[13] = ($event: any) => (this.store.isSendEmail = !this.store.isSendEmail))
          }, [
            _createVNode(_component_PrimevueButton, {
              label: "Email",
              severity: this.store.hasBeenEmailSent ? 'warning' : 'success',
              raised: "",
              class: "uppercase",
              icon: "pi pi-envelope"
            }, null, 8, ["severity"]),
            (this.store.hasBeenEmailSent)
              ? (_openBlock(), _createElementBlock("em", _hoisted_28, _hoisted_30))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (this.store.isSendEmail && this.store.emailLink !== '')
        ? (_openBlock(), _createBlock(_component_EmailList, {
            key: 6,
            modelValue: this.recipId,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((this.recipId) = $event)),
            options: this.store.emailRecipientOptions,
            optionLabel: "name",
            optionValue: "id",
            class: "md:w-30rem absolute email-list",
            onChange: _cache[15] || (_cache[15] = ($event: any) => ($options.sendEmail()))
          }, null, 8, ["modelValue", "options"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}